import {RevisionItemCategory} from "./RevisionItemCategory";

export const RevisionItemCategoryNames: Record<RevisionItemCategory, string> = {
  [RevisionItemCategory.BASIC]: "Objetivos Basicos",
  [RevisionItemCategory.SPECIFIC]: "Objetivos Especificos",
};
